<template>
  <v-container class="pa-0">
    <div v-if="info.length !== 0">
      <div
        v-if="info.orderNo != undefined && info.orderNo != '' && info.orderNo != '0'"
        class="order-item-block"
      >
        <div class="order-item">
          <div class="order-item-photo">
            <img
              onerror="this.style.display= 'none';"
              :src="info.dealImageUrl"
            />
          </div>
          <div class="order-item-content">
            <div class="item-name">{{ info.dealName }}</div>
            <div class="item-no">{{ info.orderNo }}</div>
            <div class="item-info">${{ info.orderTotal }}
              <span>x {{ info.quantity }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="message-panel">
        <div
          v-for="(conversation, i) in info.conversations.slice().reverse()"
          :key="i"
          class="message-box"
        >
          <div class="msg-top">
            <div class="msg-avatar">
              <div class="msg-avatar-circle" :class="['msg-avatar-circle', {blue: conversation.replyType == 0 ,orange: conversation.replyType > 0}]">
                <img :src="messageAvatar(conversation.replyType)" />
              </div>
            </div>
            <div class="msg-info">
              <h2>
                <div v-if="conversation.replyType">客服回覆</div>
                <div v-else>您的問題</div>
              </h2>
              <p>{{ conversation.createTime }}</p>
            </div>
          </div>
          <div class="msg-content">
            <p>{{ conversation.content }}</p>
            <div
              v-if="conversation.imageUrl"
              class="message-content-image mt-4"
            >
              <img v-gallery :src="conversation.imageUrl" />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div v-if="info.status === 4 && !newAsk" class="ask-more-btn">
      <div class="ask-btn" @click="goContactPage">
        我還有問題
      </div>
    </div>
    <div v-else class="footer-input">
      <div v-show="images.length > 0" class="input-preview">
        <div class="preview_img ml-1">
          <img
            v-for="(image, index) in images"
            :key="index"
            v-gallery
            :src="image.data"
          />
        </div>
        <div class="cancelBtn" @click="clearInputImg">
          <img :src="require('../../assets/img/cancel.svg')" />
        </div>
        <div class="message-content-time mt-1">{{ imgAlert }}</div>
      </div>
      <div class="input-area">
        <div class="image-upload">
          <!-- <label for="fileName">
            <img src="../../assets/img/image.svg" />
          </label> -->
          <UploadImg
            ref="uploadImg"
            @loading="onLoading"
            @onloadend="onLoadend"
            :preview="false"
            :noBorder="true"
            :keepBtn="true"
            :placeIcon="chatroom_upload"
          />
        </div>
        <div class="input-block mx-3">
          <AutoResizeField ref="autoResizeField">
            <textarea
              v-model="textarea"
              type="text"
              placeholder="輸入訊息"
              maxlength="1000"
              rows="1"
            />
          </AutoResizeField>
        </div>
        <div class="send-btn" @click="askAgain">
          <img src="@/assets/img/icon/chatroom_send.svg" />
        </div>
      </div>
    </div>
    <waiting-overlay v-model="submitting"></waiting-overlay>
  </v-container>
</template>

<script>
import AutoResizeField from '@/components/shared/AutoResizeField'
import WaitingOverlay from '@/components/shared/WaitingOverlay'
import UploadImg from '@/components/shared/UploadImg'

export default {
  name: 'ServiceAsking',
  components: {
    AutoResizeField,
    WaitingOverlay,
    UploadImg,
  },
  data: function() {
    return {
      textarea: '',
      images: [],
      info: [],
      imgAlert: '',
      img: null,
      submitting: false,
      newAsk: false,
      imgLoading: false,
    }
  },
  methods: {
    onLoadend(fileList) {
      this.images = fileList
    },
    onLoading(bool) {
      this.imgLoading = bool
    },
    messageAvatar(index) {
      const img = index ? 'agent' : 'customer'
      return require(`../../assets/img/service-${img}.svg`)
    },
    clearInputImg() {
      this.imgAlert = ''
      this.$refs.uploadImg.cancelInputImg()
      this.images = []
    },
    askAgain() {
      // 必輸入問題
      if (!this.textarea || this.textarea === '' || this.imgLoading) {
        return
      }
      this.submitting = true
      let imgBase64 = ''
      if (this.images.length > 0) {
        imgBase64 = this.images[0].data
      }
      const imgType = imgBase64.toString().split(';')[0]
      if (imgType.toLowerCase() == 'data:image/gif') {
        console.log('請勿上傳 gif')
        this.imgAlert = '請勿上傳gif檔'
        this.submitting = false
        return false
      }
      if (
        this.info.orderNo != undefined &&
        this.info.orderNo !== '' &&
        this.info.orderNo !== '0'
      ) {
        // 30 建立客服案件（訂單問題）
        // 訂單編號已有（info.orderNo）
        api
          .createOrderIssue(0, this.textarea, imgBase64, this.info.orderNo)
          .then(res => {
            api.getConversations(res.data).then(response => {
              this.info = response.data
              this.clearInputImg()
              this.textarea = ''
              this.submitting = false
            })
          })
          .catch(err => {
            this.submitting = false
            this.$bus.$emit('callAllert', {
              messageContent: err.code
                ? '訊息傳送失敗(錯誤代碼:' + err.code + ')'
                : '訊息傳送失敗',
            })
          })
      } else {
        // 29 建立客服案件（一般問題）
        // 已有問題類別
        const serviceNo = this.$route.params.serviceNo
        api
          .createIssue(
            this.info.categoryId,
            this.textarea,
            imgBase64,
            serviceNo
          )
          .then(res => {
            api.getConversations(res.data).then(response => {
              this.info = response.data
              this.clearInputImg()
              this.textarea = ''
              this.submitting = false
            })
          })
          .catch(err => {
            this.submitting = false
            this.$bus.$emit('callAllert', {
              messageContent: err.code
                ? '訊息傳送失敗(錯誤代碼:' + err.code + ')'
                : '訊息傳送失敗',
            })
          })
      }
    },
    goContactPage() {
      // 客服已結案，但客人「還是有問題」的按鈕
      if (
        this.info.orderNo != undefined &&
        this.info.orderNo != '' &&
        this.info.orderNo != '0'
      ) {
        this.$router.push({
          name: 'contactCustomerServicePage',
          params: { questionType: 1, orderNo: this.info.orderNo },
        })
      } else {
        this.$router.push({
          name: 'contactCustomerServicePage',
          params: { questionType: 0, orderNo: 0 },
        })
      }
    },
  },
  mounted() {
    // 33 取得案件對話
    console.log('serviceNo:' + this.$route.params.serviceNo)
    this.newAsk = this.$route.params.newAsk || 0
    api.getConversations(this.$route.params.serviceNo).then(res => {
      return (this.info = res.data)
    })
  },
  beforeDestroy() {
    this.textarea = ''
  },
}
</script>

<style lang="scss" scoped>

.container {
  position: relative;
  flex: 1 0 auto;
  background-color: #f3f5f8;
  min-height: 100vh;
}

.order-item-block {
  padding: 24px 16px 0 16px;
}

.order-code {
  font-size: 12px;
  color: #4a4a4a;
}

.order-item-photo {
  margin-right: 16px;
  width: 25%;
  height: 0;
  padding-bottom: 25%;
  background: url('../../assets/img/placholder_512.svg');
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 16px;
  overflow: hidden;
  img {
    width: 100%;
  }
}

.order-item {
  display: flex;
  padding-bottom: 24px;
  border-bottom: 2px solid #ddd;
}

.order-item-content {
  flex: 1;
  overflow: hidden;
}

.order-item-content > div:last-child {
  margin-bottom: 0px;
}

.item-name {
  font-weight: 600;
  font-size: 16px;
  color: #2a2b2b;
}

.item-no {
  color: #8e9091;
  font-size: 12px;
  margin-bottom: 3px;
}

.item-info {
  font-size: 16px;
  color: #2a2b2b;
  font-weight: 500;
  span {
    font-weight: normal;
    margin-left: 6px;
  }
}

.message-panel {
  padding: 19px 16px;
  min-height: 100%;
  padding-bottom: 96px;
}

.message-panel > div:last-child {
  margin-bottom: 0px;
}

.message-box {
  margin-bottom: 24px;
}

.message-avatar > img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.message-content-image > img,
.input-preview > .preview_img {
  width: 72px;
  flex-grow: 0;
  border-radius: 8px;
}
.preview_img img {
  width: 100%;
}
.cancelBtn {
  width: 20px;
  height: 20%;
  margin-left: -10px;
  margin-top: -10px;
}

.message-content {
  flex: 1 1 0;
  min-width: 0;
}

.message-content-text {
  font-size: 15px;
  line-height: 24px;
  color: #4a4a4a;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.message-content-text-customer {
  font-size: 14px;
  color: #383838;
  font-weight: bold;
  line-height: 1.71;
  margin-bottom: 0;
}

.message-content-time {
  font-size: 12px;
  color: #989898;
}

.footer-input {
  padding: 8px 16px;
  position: fixed;
  z-index: 11;
  bottom: 0;
  width: 100vw;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}

.input-preview {
  margin: 0px 16px 16px 36px;
  display: flex;
  position: relative;
}

.input-area {
  display: flex;
  align-items: center;
}

.input-block {
  border-radius: 8px;
  background-color: #f3f5f8;
  height: 100%;
  display: flex;
  flex-flow: column;
  flex: 1;
  padding: 10px 16px;
}

.input-block > textarea {
  width: 100%;
  resize: none;
  align-self: center;
  overflow-y: scroll;
  font-size: 14px;
  &::placeholder {
    font-size: 14px;
    color: #8e9091;
  }
}

.footer-input > img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.send-btn {
  width: 24px;
  height: 24px;
  img {
    width: 100%;
  }
}
.image-upload > label {
  display: inline-block;
  img {
    vertical-align: bottom;
  }
}
.image-upload > input {
  display: none;
}

.ask-more-title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;

  p {
    width: 100%;
    font-size: 14px;
    color: #222222;
    text-align: center;
    margin: 11.5px 0;
    background-color: #f6f6f6;
  }
}

.ask-more-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  padding: 16px 0 20px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f3f5f8;
  .ask-btn {
    font-size: 16px;
    font-weight: 600;
    color: #1ea7fc;
    letter-spacing: -0.4px;
  }
}

.msg-top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .msg-avatar {
    margin-right: 10px;
    .msg-avatar-circle {
      background-color: #666;
      position: relative;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      &.blue {
        background-color: #1ea7fc !important;
      }
      &.orange {
        background-color: #ffbf56 !important;
      }
      img{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .msg-info {
    h2 {
      font-size: 14px;
      color: #2a2b2b;
      font-weight: normal;
    }
    p {
      color: #8e9091;
      font-size: 12px;
    }
  }
}

.msg-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  p {
    color: #2a2b2b;
    font-size: 16px;
  }
}

</style>
